// Clinic Configuration for Reno Dental care and Orthodontics
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Reno Dental care and Orthodontics",
  clinicId: "renodentalcareandorthodontics",
  clinicUrl: "https://renodentalcareandorthodontics.com",
  // Contact Information
  phoneNumber: "775-339-9893",
  phoneNumberRaw: "+17753399893", // For tel: and sms: links
  email: "dentalcare@renodentalcareandorthodontics.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=renodentalcareandorthodontics&agentId=bad3f86d-6fd3-4992-93eb-6b921653a129",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/renodentalcareandorthodontics/voice",

  // Location
  address: "8040 S Virginia St, Suite 1 , Reno, NV 89511",
  addressShort: "8040 S Virginia St, Suite 1, Reno, NV 89511",
  city: "Reno",
  hcity: "Reno",
  state: "Nevada",
  stateShortForm: "NV",
  PostalCode: "89511",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/XWwTxKnmGrJHeUXP8",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d89182.56021793869!2d-119.90964641044987!3d39.476432399468486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80991550964234f1%3A0x3eeb300007556969!2sDentist%20in%20Reno!5e1!3m2!1sen!2sin!4v1770214193168!5m2!1sen!2sin',
  iframeTitle: "Reno Dental care and Orthodontics",

  //membership
  membership: "https://member.kleer.com/?slug=ZV6U",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinReno",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/reno-dental-care-and-ortho?utm_source=practice&utm_medium=email&m=66192",


  // Analytics
  gaMeasurementId: "G-9SRYY55NVV",
  clarityProjectId: "tetwfq1mjm",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-16894351275",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-16894351275/foEFCO3Tt5QcEKuv7fc-",
    "contact_form_success": "AW-16894351275/dgh1CL2vwoYcEKuv7fc-",
    "call_back_success": "AW-16894351275/UNHGCM2et4YcEKuv7fc-",
    "chatbot_phone_click": "AW-16894351275/zZaYCMfozJQcEKuv7fc-",
    "chatbot_voice_call": "AW-16894351275/dNpmCOnVt5QcEKuv7fc-",
    "book_appointment_success": "AW-16894351275/MnHrCI6yroYcEKuv7fc-",
    "Confirm-Booking": "AW-16894351275/9YQlCM_qzJQcEKuv7fc-",
    "Submit-Payment": "AW-16894351275/qeC8CKDWzJQcEKuv7fc-",
    // Secondary — observation/reporting only
    "sms_click": "AW-16894351275/zdg0CIvXt5QcEKuv7fc-",
    "directions_click": "AW-16894351275/CQojCNLqzJQcEKuv7fc-",
    "email_click": "AW-16894351275/xJJJCKbXt5QcEKuv7fc-",
    "map_click": "AW-16894351275/4o61CI7Xt5QcEKuv7fc-",
    "social_media_click": "AW-16894351275/-J8ACKzXt5QcEKuv7fc-",
    "financing_click": "AW-16894351275/sRQjCO3qzJQcEKuv7fc-",
    "membership_click": "AW-16894351275/li6TCP3ZzJQcEKuv7fc-",
    "outbound_link_click": "AW-16894351275/xecUCInpzJQcEKuv7fc-",
    "chat_send": "AW-16894351275/-O_ICJTlzJQcEKuv7fc-",
    "chatbot_quick_action": "AW-16894351275/NTyjCI_pzJQcEKuv7fc-",
    "chatbot_insurance_upload": "AW-16894351275/j9drCKLZt5QcEKuv7fc-",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/renodentalcareandorthodontics",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/renodentalcareandorthodontics",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/renodentalcareandorthodontics",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://renodentalcareandorthodontics.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/RenoDentalCareandOrthodontics",
    instagram: "https://www.instagram.com/reno_dental_care/",
    twitter: "https://x.com/Reno_DentalCare",
    linkedin: "https://www.linkedin.com/company/dentist-in-reno/",
    youtube: "https://www.youtube.com/@RenoDentalcare",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/14201265382418589596/profile?hl=en-GB&fid=4533770226559707497",
    facebook: "https://www.facebook.com/dentistinreno/",
    yelp: "https://www.yelp.com/biz/reno-dental-care-and-orthodontics-reno",
  },

  // Open Dental Configuration
  defaultProvNum: 3607,
  defaultOpNum: 50,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 51,
      AppointmentTypeNum: 6,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 50, // DEFAULT_OP_NUM
      AppointmentTypeNum: 4,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 50, // DEFAULT_OP_NUM
      AppointmentTypeNum: 4,
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "17753476701",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

